<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.lookup">
    <div class="banner center" [ngStyle]="{'max-width' : lookupType == LookupType.None ? '500px' : '1000px'}">
        <div *ngIf="lookupType == LookupType.None">
            <div class="row row_header freeze_height">
                <div class="col-12">
                    {{localService.languageContent.lookup.header}}
                </div>
            </div>
            <div class="custom_rows_body">
                <div *ngIf="(localService.lookupTypes && localService.lookupTypes.length > 0)" class="item-found">
                    <div class="row styled_row" *ngFor="let item of localService.lookupTypes">
                        <div class="col-12">
                            <a class="button" [routerLink]="['/lookups' + localService.basicParamsString,item.key]">
                                <i class="material-icons button icon_adjust">account_tree</i>
                            </a>
                            {{item.value}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="lookupType != LookupType.None">
            <div class="row row_header freeze_height" style="border: none;">
                <div class="col-6" style="text-align: left;">
                    <a class="button" [routerLink]="['/lookups' + localService.basicParamsString,0]">
                        <i class="material-icons button icon_adjust">arrow_back</i>
                    </a>
                    <span>{{selectedLookUpName}}</span>
                    <button class="button_icon button_icon_color" (click)="onAction(2)"
                        style="color: red !important;margin-left: 10px;top: 5px;">
                        delete_sweep
                    </button>
                </div>
                <div class="col-6" style="text-align: right;">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="isShowInActive" (change)="onLoad()" />
                        <span class="normal_color">{{localService.languageContent.lookup.show_inactive}}</span>
                    </label>
                </div>
            </div>
            <div class="row row_header freeze_height">
                <div class="col-4">
                    <div style="float: left;margin-top: 5px; margin-bottom: -5px;">
                        <button class="button_icon button_icon_color" (click)="onAction(3)">
                            file_upload
                        </button>
                        <button class="button_icon button_icon_color" (click)="onAction(4)">
                            file_download
                        </button>
                    </div>
                    {{localService.languageContent.lookup.value}}
                </div>
                <div class="col-8">
                    {{localService.languageContent.table.title}}
                    <div class="icon_action_header">
                        <button class="button_icon button_icon_color" (click)="onAction(1)">
                            note_add
                        </button>
                    </div>
                </div>
            </div>
            <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                <div *ngIf="(source && source.items.length > 0)" class="item-found">
                    <div class="row styled_row" *ngFor="let item of source.items">
                        <div class="col-4">
                            <button class="button_icon icon_adjust"
                                title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                                (click)="onActiveInactiveStatus(item.key)"
                                [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ?
                                "toggle_on" : "toggle_off"}}</button>
                            <button class="button_icon button_icon_color icon_adjust" (click)="localService.copyContent(item.v1)">
                                content_copy
                            </button>
                            <span class="en">{{item.v1}}</span>
                        </div>
                        <div class="col-8">
                            <button class="button_icon button_icon_color icon_adjust" (click)="onAction(1,item.key)">
                                edit
                            </button>
                            <span [ngClass]="localService.getLanguageCode(item.v6)">
                                {{item.v5}}
                            </span>
                            <button class="button_icon button_icon_color" (click)="onAction(2,item.key)"
                                style="color: red !important;margin-left: 10px;top: 5px;float: right;">
                                delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="lookupType != LookupType.None && source && source.paging" [paging]="source.paging"
        (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<div>
    <app-language-selection [(isOpenPopup)]="isOpenLanguageSelection" [isInnerUsage]="true"
        (onClose)="onLanguageSelected($event)"></app-language-selection>
</div>
<div style="display:none">
    <app-file-upload [Id]="elementIds.file" [fileUploadFor]="FileUploadFor.Lookups" [forId2]="selectedLanguage"
        [type]="lookupType"></app-file-upload>
</div>
<div *ngIf="lookupType != LookupType.None">
    <app-lookup-edit [(isOpenPopup)]="isOpenLookup" [lookupType]="lookupType" [id]="selectedLookupId"
        (onClose)="onLoad()" />
    <app-message-box *ngIf="isOpenConfirmationBox" [IsConfirmationType]="true" (onClose)="onDelete($event)"
        [IsPopup]="true" />
</div>